export const tr = {
    'link-domain-not-match-main': 'Bağlantı, ana sitenin sayfasına yönlendirmiyor',
    'sitelink-descr-allowed-symbols': 'Hızlı bağlantı açıklamasında geçersiz karakterler',
    'sitelink-descr-dublicate': 'Hızlı bağlantıların açıklamaları farklı olmalıdır',
    'sitelink-descr-max-length': 'Bir hızlı bağlantı için izin verilen {maxLength} karakter sınırlaması aşıldı.',
    'sitelink-descr-no-empty': 'Hızlı bağlantının açıklamasını belirtin',
    'sitelink-descr-not-allowed-symbols': 'Hızlı bağlantı açıklamasında geçersiz karakterler',
    'sitelink-href-invalid': 'Site adresi belirtilmedi veya yanlış belirtildi',
    'sitelink-href-length': 'İzin verilen bağlantı uzunluğu {maxLength} karakter aşıldı',
    'sitelink-title-empty': 'Hızlı bağlantı için başlık belirtilmelidir',
    'sitelink-title-max-length': 'Hızlı bağlantı başlığının izin verilen uzunluğu {maxLength} karakter aşıldı',
    'sitelink-title-restricted-chars-in-field':
        'Hızlı bağlantı başlığında sadece Latin harfleri, Türkçe, Rusça, Ukraynaca, Kazakça ve Belarusça harflerin yanı sıra "!" ve "?" dışındaki noktalama işaretleri kullanılabilir.',
    'sitelinks-common-title-max-length': 'Bağlantı başlığının izin verilen uzunluğu {maxLength} karakter aşıldı',
    'sitelinks-duplicate-errors': 'Bağlantı başlıkları farklı olmalıdır',
    'sitelinks-first-block-common-title-max-length':
        'İlk dört hızlı bağlantının başlığı için izin verilen uzunluk {maxLength} karakter aşıldı',
    'sitelinks-need-to-save': 'Reklamı kaydetmeden önce hızlı bağlantıların düzenlenmesini tamamlayın',
    'sitelinks-second-block-common-title-max-length':
        'Ek dört hızlı bağlantının başlığı için izin verilen uzunluk {maxLength} karakter aşıldı',
    'sitelinks-unknown-error': 'Bilinmeyen bir hata oluştu',
    'turbo-page-invalid': 'Turbo sayfa belirtilmedi'
};
